const OPTIONS = { dragFree: true };

const isMobile = window.matchMedia("(max-width: 768px)").matches;

function initProducts() {
  if (!isMobile) return;

  const productsViewportNode = document.querySelector(
    `[handle="anchor-products"]:has([handle="anchor-products-container"])`,
  );

  const addScrollBarListener = (emblaApi, scrollBarNode) => {
    if (!emblaApi || !scrollBarNode) return;

    let value = 0;

    const scrollToProgress = (progress) => {
      const { animation, limit, target, scrollProgress, scrollBody, scrollTo } =
        emblaApi.internalEngine();

      animation.stop();

      const currentProgress = scrollProgress.get(target);
      const allowedProgress = Math.min(Math.max(progress, 0), 1);
      const progressToTarget = allowedProgress - currentProgress;
      const distance = progressToTarget * limit.length * -1;

      scrollBody.useDuration(0);
      scrollTo.distance(distance, false);
    };

    const onScrollBarChange = (event) => {
      const target = event.target;
      const newProgress = parseFloat(target.value);
      value = newProgress;
      scrollToProgress(newProgress);
    };

    const setValue = (value) => {
      value = emblaApi.scrollProgress();
      scrollBarNode.value = value.toString();
    };

    emblaApi.on("scroll", (emblaApi) => {
      setValue(emblaApi.scrollProgress());
    });

    scrollBarNode.addEventListener("input", onScrollBarChange);
    setValue(emblaApi.scrollProgress());
  };

  const progressBar = document.createElement("input");
  progressBar.classList.add("anchor-products-progress-bar");
  progressBar.setAttribute("type", "range");
  progressBar.setAttribute("min", "0");
  progressBar.setAttribute("max", "1");
  progressBar.setAttribute("value", "0");
  progressBar.setAttribute("step", "0.1");
  productsViewportNode.appendChild(progressBar);

  const productsEmblaApi = EmblaCarousel(productsViewportNode, OPTIONS);
  addScrollBarListener(productsEmblaApi, progressBar);
}

function initAnhcorInfoImagesPc() {
  const infos = document.querySelectorAll(`[handle="anchor-infos"]`);

  const toggleDotsActive = (emblaApi, dotsNode) => {
    const dots = Array.from(dotsNode.children);
    const previous = emblaApi.previousSnap() || 0;
    const selected = emblaApi.selectedSnap() || 0;
    dots[previous]?.classList.remove("active");
    dots[selected]?.classList.add("active");
  };

  const addDotsClickHandlers = (emblaApi, dotsNode) => {
    const dots = Array.from(dotsNode.children);
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        emblaApi.goTo(index);
      });
    });
  };

  infos.forEach((info) => {
    const imagesLength = info.querySelectorAll(`[handle="image"]`).length;

    if (!imagesLength || imagesLength <= 1) {
      return;
    }

    const viewportNode = info.querySelector(`[handle="anchor-images"]`);
    const emblaApi = EmblaCarousel(viewportNode);

    const length = emblaApi.slideNodes().length;

    const dotsNode = document.createElement("div");
    dotsNode.classList.add("anchor-images-dots");
    dotsNode.innerHTML = Array.from({ length }, (_) => `<span></span>`).join(
      "",
    );
    viewportNode.appendChild(dotsNode);

    toggleDotsActive(emblaApi, dotsNode);
    addDotsClickHandlers(emblaApi, dotsNode);

    emblaApi.on("select", () => {
      toggleDotsActive(emblaApi, dotsNode);
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initProducts();
  initAnhcorInfoImagesPc();
});
